import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Header({ children, className, as, ...rest }) {
    const Component = as ?? "header";
    return (_jsx(Component, { className: classNames("cvr-header", className), ...rest, children: children }));
}
